<template>
  <div class="myWrap">
    <div class="content">
      <div class="topPic">
        <van-image
            width="50px"
            height="50px"
            fit="cover"
            :src="photoSrc"
            style="border-radius:50%;border:1px solid #fff;"
        />
        <span style="margin-top:1rem;">{{ userInfo.userName }}</span>
      </div>
      <van-cell-group class="item-row">
        <van-cell>
          <div slot="title">
            <div class="cell-left">
              <van-icon name="user-circle-o" />
              <span class="van-cell-text">{{$t('append_field.account_type') }}</span>
            </div>
            <span class="cell-right addr">
              {{ userInfo.userType === 0 ? $t('append_field.user_type', {level: userInfo.level}) : $t('append_field.customer_type', {level: userInfo.level}) }}</span>
          </div>
        </van-cell>
        <van-cell v-if="userInfo.userType === 0">
          <div slot="title">
            <div class="cell-left">
              <van-icon name="manager-o" />
              <span class="van-cell-text">{{$t('append_field.superior_name')}}</span>
            </div>
            <span class="cell-right addr">{{ userList.psName  }}</span>
          </div>
        </van-cell>
        <van-cell v-else>
          <div slot="title">
            <div class="cell-left">
              <van-icon name="location-o" />
              <span class="van-cell-text">{{$t('append_field.customer_address')}}</span>
            </div>
            <span class="cell-right addr">{{ userInfo.addr ? userInfo.addr : this.$t('append_field.none') }}</span>
          </div>
        </van-cell>
        <van-cell>
          <div slot="title">
            <div class="cell-left">
              <van-icon name="clock-o" />
              <span class="van-cell-text">{{$t('append_field.account_period')}}</span>
            </div>
            <span class="cell-right">{{ userInfo.validTime ? userInfo.validTime : this.$t('append_field.none') }}</span>
          </div>
        </van-cell>
        <van-cell>
          <div slot="title">
            <div class="cell-left">
              <van-icon name="idcard" />
              <span class="van-cell-text">{{$t('append_field.memory_status')}}</span>
            </div>
            <span class="cell-right">{{ displaySize(userInfo.lastSize) }}</span>
          </div>
        </van-cell>
        <van-cell @click="goContact" >
          <div slot="title">
            <div class="cell-left">
              <van-icon name="contact-o" />
              <span class="van-cell-text">{{$t('append_field.user')}}</span>
            </div>
            <span class="cell-right"> <van-icon name="arrow"/> </span>
          </div>
        </van-cell>
        <van-cell @click="searchCustomers" v-if="$auth.hasPerms('customer:data:search')">
          <div slot="title">
            <div class="cell-left">
              <van-icon name="search" />
              <span class="van-cell-text">{{$t('append_field.customer_title')}}</span>
            </div>
            <span class="cell-right"> <van-icon name="arrow"/> </span>
          </div>
        </van-cell>
        <van-cell @click="toAudit" v-if="$auth.hasPerms('system:material:audit')">
          <div slot="title">
            <div class="cell-left">
              <van-icon name="todo-list-o" />
              <span class="van-cell-text">{{ $t('append_field.content_review') }}</span>
            </div>
            <span class="cell-right"> <van-icon name="arrow"/> </span>
          </div>
        </van-cell>
        <van-cell @click="goMaterial" v-if="$auth.hasUrl('/material')">
          <div slot="title">
            <div class="cell-left">
              <van-icon name="flower-o" />
              <span class="van-cell-text">{{$t('append_field.material_management')}}</span>
            </div>
            <span class="cell-right"> <van-icon name="arrow"/> </span>
          </div>
        </van-cell>
        <van-cell @click="goMaterialRecycleBin" v-if="$auth.hasPerms('material:data:recycleBin')">
          <div slot="title">
            <div class="cell-left">
              <van-icon name="delete-o" />
              <span class="van-cell-text">{{ $t('append_field.material_recycle_bin') }}</span>
            </div>
            <span class="cell-right"> <van-icon name="arrow"/> </span>
          </div>
        </van-cell>
<!--
        <van-cell @click="goRechargeCenter" v-if="$auth.hasPerms('system:pay:view')">
          <div slot="title">
            <div class="cell-left">
              <van-icon name="gold-coin-o" :badge="totalValidCount >0 ?totalValidCount:''" />
              <span class="van-cell-text">{{  $t('recharge_center.title') }}</span>
            </div>
            <span class="cell-right"> <van-icon name="arrow"/> </span>
          </div>
        </van-cell>-->
        <van-cell @click="goDownload">
          <div slot="title">
            <div class="cell-left">
              <van-icon name="orders-o" />
              <span class="van-cell-text">{{$t('append_field.video_tutorial')}}</span>
            </div>
            <span class="cell-right"> <van-icon name="arrow"/> </span>
          </div>
        </van-cell>
        <van-cell @click="goLanguage">
          <div slot="title">
            <div class="cell-left">
              <van-icon name="info-o" />
              <span class="van-cell-text">{{$t('append_field.language')}}</span>
            </div>
            <span class="cell-right"> <van-icon name="arrow"/> </span>
          </div>
        </van-cell>

        <van-cell @click="logout">
          <div slot="title">
            <div class="cell-left">
              <van-icon name="revoke" />
              <span class="van-cell-text">{{$t('append_field.exit')}}</span>
            </div>
            <span class="cell-right"> <van-icon name="arrow"/> </span>
          </div>
        </van-cell>
      </van-cell-group>

    </div>
    <van-dialog v-model="dialogShow"
                class="contact"
                :title="$t('append_field.user')" show-cancel-button
                @confirm="onSubmitUser"
                :beforeClose="vBeforeClose"
                @cancel="onCancel">
        <van-field
            :label="$t('append_field.userName')"
            v-model="userInfo.userName"
            disabled
            clearable>
        </van-field>
        <van-field
            :label="$t('append_field.phone_number')"
            v-model="phone"
            type="number"
            :placeholder="$t('append_field.enter_phone_number')"
            clearable>
        </van-field>

        <van-field
            :label="$t('append_field.email')"
            v-model="email"
            :placeholder="$t('append_field.enter_email')"
            clearable>
        </van-field>

    </van-dialog>
    <van-dialog v-model="languageShow" :title="$t('append_field.language')"
                show-cancel-button
                @confirm="handleSetLanguage(language)"
                @cancel="languageShow = false"
                class="select-groupings">
      <div >
        <van-radio-group v-model="language">
          <van-cell-group  class="language">
            <van-cell
                v-for="(item, index) in columns"
                clickable
                :key="index"
                :title="item.text"
                @click="language = item.value">
              <template #right-icon>
                <van-radio :name="item.value" />
              </template>
            </van-cell>
          </van-cell-group>
        </van-radio-group>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import {mapActions } from 'vuex'
import {Dialog, Toast} from 'vant'
import {vBeforeClose} from "@/utils/tool";
import qs from "qs";
import {getLanguage} from "@/lang";
import Cookies from "js-cookie";
import {environment} from "@/assets/js/user_environment";
import $auth from "@/utils/auth";
export default {
  name: 'My',
  data() {
    return {
      userInfo: {},
      photoSrc: '',
      dialogShow:false,//个人信息弹窗
      email:'',
      phone:'',
      originalEmail: '', // 保存原始 email
      originalPhone: '', // 保存原始 phone
      languageShow:false ,//语言选择弹窗
      language:'',
      columns: [
        {
          text: '中文',
          value: 'zh'
        },
        {
          text: 'English',
          value: 'en'
        },
        {
          text: '日本語',
          value: 'ja'
        },
        {
          text: '한국어',
          value: 'ko'
        },
        {
          text: 'हिंदी',
          value: 'hi'
        },
        {
          text: 'Español',
          value: 'es'
        },
        {
          text: 'Portugal',
          value: 'pt'
        },
        {
          text: 'Français',
          value: 'fr'
        } ,
        {
          text: 'Deutsch',
          value: 'de'
        },
        {
          text: 'Pусский',
          value: 'ru'
        }
      ],
      environment,
      userList:[],
      totalValidCount:0
    }
  },
  computed: {
    $auth() {
      return $auth
    }
  },
  mounted() {
    this.language = Cookies.get('language') || getLanguage()
    document.title = this.$t('append_field.personal_center')
    this.getUserInfo()
    this.fetchValidCount()
    this.userList = JSON.parse(localStorage.getItem('userList'))



  },
  methods: {
    getLanguage,
    vBeforeClose,
    ...mapActions(['changeTopTitle', 'changeTopIconStatus', 'setParentPage']),

    getUserInfo() {
      let _this = this
      this.$ajax.get('/etv/selectUserInfo.json').then(res => {
        let data = res.data.data
        let level = parseInt(data.level)
        if (level === 1) {
          _this.photoSrc = '/static/images/level1.png'
        } else if (level === 2) {
          _this.photoSrc = '/static/images/level2.png'
        } else if (level === 3) {
          _this.photoSrc = '/static/images/level3.png'
        } else if (level === 4) {
          _this.photoSrc = '/static/images/level4.png'
        }
        _this.phone = data.phone
        _this.email = data.email
        _this.userInfo = data

      })
    },
    toAudit() {
      this.$router.push({path: '/audit'})
    },

    goMaterial(){
      this.$router.push({path: '/material'})
    },
    goMaterialRecycleBin() {
      this.$router.push({ path: '/materialRecycleBin' })
    },

    logout() {
      Dialog.confirm({
        title: this.$t('append_field.logout')
        , message: this.$t('append_field.confirm_logout'),
      }).then(() => {
        this.$ajax.post('/etv/logout.json').then(() => {
          localStorage.removeItem('token')
          let displayFlag= localStorage.getItem("displayFlag") //显示的频次
          if(displayFlag == 1 ){
            localStorage.removeItem('isPushNotice')
          }
          this.$router.push('/login')
        })
      }).catch(() => {
      })

    },

    goContact(){
      // 打开弹窗时保存原始值
      this.originalPhone = this.phone
      this.originalEmail = this.email
      this.dialogShow = true
    },
    onSubmitUser(){
      if (this.phone.length < 9) {
        Toast(this.$t('append_field.phone_number_too_short'))
        return
      }

      this.$ajax.post('/etv/updateAccountInfo.json', qs.stringify({
        phone: this.phone,
        email: this.email,
        })).then(res => {

        if (res.data.code === 0 ) {
          Toast(res.data.msg)
          this.dialogShow = false
        }else {
          Toast(res.data.msg )
        }
      })
    },
    onCancel() {
      // 取消时恢复原始值
      this.phone = this.originalPhone
      this.email = this.originalEmail
      this.dialogShow = false
    },
    goLanguage(){
      this.languageShow=true
      this.language=Cookies.get('language') || getLanguage()
    },
    handleSetLanguage(lang) {
      this.$i18n.locale = lang
      this.$store.dispatch('setLanguage', lang)
      getLanguage()
      location.reload()
    },
    goDownload(){
      this.$router.push({path: '/myExplain',query:{type:'h5'}})
      //window.open('https://etv.ids.esoncloud.com/#/myExplain')
    },
    goRechargeCenter() {
      this.$router.push({ path: '/rechargeCenter' })
    },
    goInvoiceCenter() {
      this.$router.push({ path: '/invoiceCenter' })
    },
    displaySize(lastSize) {
      const sizeInMB = parseFloat(lastSize)
      if (isNaN(sizeInMB)) {
        return 'Invalid size'
      }
      if (sizeInMB < 1024) {
        return `${sizeInMB.toFixed(2)} MB`
      } else {
        const sizeInGB = (sizeInMB / 1024).toFixed(2) // 保留两位小数
        return `${sizeInGB} GB`
      }
    },
    searchCustomers(){
      this.$router.push({path: '/customers',query:{account:this.userInfo.userName}})
    },
    fetchValidCount() {
      this.$ajax.get("/etv/getClientRenewInfo.json").then(res => {
        if (res.data.code === 0) {
          const validCount = Number(res.data.data.validCount) || 0
          const valid30Count = Number(res.data.data.valid30Count) || 0
          this.totalValidCount = validCount + valid30Count
        } else {
          this.totalValidCount = 0
        }
      })
    },
  },
}
</script>

<style lang="scss">
@import "../../public/static/css/app";

.myWrap {
  height: calc(100% - 70px) !important;
  overflow-y: auto;
  overflow-y: auto;

  .content {
    height: 100%;

    .topPic {
      height: 130px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      background: #006EFF;
      color: #fff;

      .van-image {
        border-radius: 50%;
        overflow: hidden;
      }
    }

    .dataWrap {
      background: #006EFF;
      color: #fff;
      height: 4rem;
      border-top: 1px solid #fff;

      .nut-col {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        height: 100%;
        overflow: hidden;

        &:first-child {
          border-right: 1px solid #fff;
        }

        span {
          width: 100%;
          word-wrap: break-word;
          text-align: center;
          max-height: 40px;
          overflow: hidden;
        }
      }
    }

    .item-row {
      margin: 10px 0;
      background: #fff;
      .cell-left {
        display: flex;
        align-items: center;
      }

      .cell-right {
        float: right;
      }

      .van-icon {
        font-size: 18px;
        margin-right: 4px;
      }
      .van-empty{
        display: flex;
        align-items: flex-end;
        justify-content: center;
      }

    }
    .van-cell{
      padding: 16px ;
    }
    .van-cell__title {
      & > div {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }

    }

  }
  .addr{
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    max-width: 180px;
  }
  .bigBtn {
    padding: 0 20px;

    .van-button--large {
      border-radius: 40px;
    }
  }
  .contact{
    .van-field__body{
      border-bottom: #131212 1px solid;
    }
    .van-field__label{
      width: 100%;
    }
    .van-cell{
      display: flex;
      flex-direction: column;
    }
  }
  .select-groupings{
    .van-cell{
      padding: 20px;
    }
    .language{
      height: 300px;
      overflow-y: auto;
    }
  }
  [class*=van-hairline]::after{
    border: none;
  }
}
</style>
